import { Button } from 'antd'
import { ChevronDown, Plus } from 'lucide-react'
import type { ContractDocumentStatus } from '@super-mega/server/contracts/contract'
import { AuthorizedDropdown } from '@/features/authorization/authorized-dropdown.tsx'
import { Authorized } from '@/features/authorization/authorized.tsx'

export function ContractDocumentToolbar({
  compact,
  pending,
  selectedCount,
  total,
  onBatch,
  onAll,
  onCreate
}: {
  compact: boolean
  pending: boolean
  selectedCount: number
  total: number
  onBatch: (mode: 'ids' | 'search', status?: ContractDocumentStatus) => void
  onAll: (status: 'effective' | 'voided') => void
  onCreate: () => void
}) {
  const menu = (mode: 'ids' | 'search') => ({
    items: [
      { key: 'status', label: '修改状态' },
      { key: 'effective', label: '生效' },
      { key: 'voided', label: '作废', danger: true }
    ],
    onClick: ({ key }: { key: string }) => onBatch(mode, key === 'effective' || key === 'voided' ? key : undefined)
  })
  return (
    <div className="flex max-w-full flex-wrap items-center justify-end gap-2">
      <AuthorizedDropdown resource="contract.document" menu={menu('ids')} disabled={pending || !selectedCount}>
        <Button disabled={pending || !selectedCount}>
          批量操作 <ChevronDown aria-hidden size={14} />
        </Button>
      </AuthorizedDropdown>
      {compact ? (
        <>
          <AuthorizedDropdown
            resource="contract.document"
            disabled={pending}
            menu={{
              items: [
                { key: 'effective', label: '一键生效' },
                { key: 'voided', label: '一键作废', danger: true }
              ],
              onClick: ({ key }) => onAll(key as 'effective' | 'voided')
            }}
          >
            <Button className="sm:hidden!" disabled={pending}>
              全部合同 <ChevronDown aria-hidden size={14} />
            </Button>
          </AuthorizedDropdown>
          <Authorized permissions={['contract.document.activate']}>
            <Button className="hidden! sm:inline-flex!" disabled={pending} onClick={() => onAll('effective')}>
              一键生效
            </Button>
          </Authorized>
          <Authorized permissions={['contract.document.void']}>
            <Button className="hidden! sm:inline-flex!" danger disabled={pending} onClick={() => onAll('voided')}>
              一键作废
            </Button>
          </Authorized>
        </>
      ) : (
        <>
          <AuthorizedDropdown resource="contract.document" menu={menu('search')} disabled={pending || !total}>
            <Button disabled={pending || !total}>
              按搜索批量操作 <ChevronDown aria-hidden size={14} />
            </Button>
          </AuthorizedDropdown>
          <Authorized permissions={['contract.document.create', 'contract.document.confirm']}>
            <Button type="primary" icon={<Plus aria-hidden size={16} />} disabled={pending} onClick={onCreate}>
              生成合同
            </Button>
          </Authorized>
        </>
      )}
    </div>
  )
}
